import { render } from "./LabelRenderer.vue?vue&type=template&id=3dba42c0&scoped=true"
import script from "./LabelRenderer.vue?vue&type=script&lang=js"
export * from "./LabelRenderer.vue?vue&type=script&lang=js"

import "./LabelRenderer.vue?vue&type=style&index=0&id=3dba42c0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dba42c0"]])

export default __exports__